import type { WarehouseDTO } from '@horology/shared-types';
import { api } from '../../lib/api';

export async function listWarehouses(): Promise<WarehouseDTO[]> {
  const { data } = await api.get<WarehouseDTO[]>('/api/warehouses');
  return data;
}

export interface WarehouseInput {
  code: string;
  name: string;
  address?: string | null;
  isDefault?: boolean;
}

export async function createWarehouse(body: WarehouseInput): Promise<WarehouseDTO> {
  const { data } = await api.post<WarehouseDTO>('/api/warehouses', body);
  return data;
}

export async function updateWarehouse(id: number, body: Partial<WarehouseInput>): Promise<WarehouseDTO> {
  const { data } = await api.patch<WarehouseDTO>(`/api/warehouses/${id}`, body);
  return data;
}

export interface TransferInput {
  productId: number;
  fromWarehouseId: number;
  toWarehouseId: number;
  quantity: number;
  note?: string;
}

export async function transferStock(body: TransferInput): Promise<{ ok: boolean }> {
  const { data } = await api.post<{ ok: boolean }>('/api/warehouses/stock/transfer', body);
  return data;
}

export interface AdjustInput {
  productId: number;
  warehouseId: number;
  delta: number;
  unitCost?: number;
  note?: string;
}

export async function adjustStock(body: AdjustInput): Promise<unknown> {
  const { data } = await api.post('/api/warehouses/stock/adjust', body);
  return data;
}

export interface LowStockRow {
  productId: number;
  warehouseId: number;
  quantity: string;
  minStock: string;
}

export async function listLowStock(): Promise<LowStockRow[]> {
  const { data } = await api.get<LowStockRow[]>('/api/warehouses/stock/low');
  return data;
}
